'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "Mali Vadhu Var Suchak Mandal Pune" },
  { label: "Mali Vadhu Var Suchak" },
  { label: "Mali Vadhu Var Suchak Mandal" },
  { label: "Mali Vadhu Var Pune" },
  { label: "Mali Vadhu Var Whatsapp Group" },
  { label: "Mali Vadhu Var Whatsapp Group Link" },
  { label: "Mali Vadhu Var Suchak Kendra" },
  { label: "Mali Vadhu Var Suchak Mandal Nashik" },
  { label: "Mali Vadhu Var Photos" },
  { label: "Mali Vadhu Var Suchak Pune" },
  { label: "Mali Vadhu Var Suchak Whatsapp Group Link" },
  { label: "Mali Vadhu Var Suchak Mandal Hadapsar, Pune" },
  { label: "Mali Vadhu Var Suchak Mandal Satara" },
  { label: "Mali Vadhu Var Suchak Maharashtra" },
  { label: "Mali Vadhu Var.com" },
  { label: "Lingayat Mali Vadhu Var Suchak" },
  { label: "Mali Vadhu Var Suchak Mandal Phaltan" },
  { label: "Mali Vadhu Var Suchak Kendra Pune" },
  { label: "Mali Samaj Vadhu List" },
  { label: "Mali Samaj Vadhu Var Suchak Pune" },
  { label: "Mali Samaj Vadhu List pdf" },
  { label: "Girl Mali Samaj Vadhu Photo" },
  { label: "Mali Samaj Vadhu Var Whatsapp Group" },
  { label: "Mali Samaj Vadhu List Female" },
  { label: "Mali Samaj Vadhu Photo" },
  { label: "Kshatriya Mali Samaj Hall" },
  { label: "Mali Samaj Vadhu Var" },
  { label: "Mali Samaj Vadhu Var Whatsapp Group Link" },
  { label: "Nashik Mali Samaj Vadhu Photo" },
  { label: "Mali Samaj Var List" },
  { label: "Mali Samaj Vadhu Var Suchak Satara" },
  { label: "Mali Samaj Vadhu List Female Photo" },
  { label: "Mali Samaj Matrimony" },
  { label: "Mali Matrimony" },
  { label: "Mali Matrimony Pune" },
  { label: "Phool Mali Matrimony" },
  { label: "Mali Matrimony Whatsapp Group Link" },
  { label: "Marathi Mali Matrimony" },
  { label: "Lingayat Mali Matrimony" },
  { label: "Jire Mali Matrimony" },
  { label: "Mali Matrimony Airoli" },
  { label: "Phul Mali Matrimony" },
  { label: "Mali Matrimony Maharashtra" },
  { label: "Mali Matrimony Sites" },
  { label: "Mali Matrimony Nashik" },
  { label: "Mali Matrimony Brides" },
  { label: "Chaukalshi Mali Matrimony" },
  { label: "Hindu Mali Matrimony" },
  { label: "Mali Matrimony Grooms" },
  { label: "Chaukalshi Mali Matrimony Alibag" },
  { label: "Mali Matrimony Login" },
  { label: "Vimal Kanade Mali Matrimony" },
  { label: "Mali Matrimony in Pune" },
  { label: "Mali Community Matrimonial" },
  { label: "Mali Community in Maharashtra" },
  { label: "Mali Community" },
  { label: "Mali Samaj" },
  { label: "Phool Mali Grooms" },
  { label: "Phool Mali Brides" },
  { label: "Lingayat Mali Grooms" },
  { label: "Lingayat Mali Brides" },
  { label: "Haldi Mali Grooms" },
  { label: "Haldi Mali Brides" },
  { label: "Jire Mali Grooms" },
  { label: "Jire Mali Brides" },
  { label: "Gase Mali Grooms" },
  { label: "Gase Mali Brides" },
  { label: "Chaukalshi Mali Grooms" },
  { label: "Chaukalshi" },
  { label: "Mali Brides" },
  { label: "Kanch Mali Grooms" },
  { label: "Kanch Mali Brides" },
  { label: "Kosare Mali Grooms" },
  { label: "Kosare Mali Brides" },
  { label: "Lonare Mali Grooms" },
  { label: "Panchkalshi Mali Grooms" },
  { label: "माळी वधू वर पुणे, महाराष्ट्र" },
  { label: "माळी वधू वर पुणे महाराष्ट्र" },
  { label: "माळी वधू" },
  { label: "माळी वधू वर" },
  { label: "माळी वधू पाहिजे" },
];

export default function MaliVadhuVar() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="माळी समाजातील वधू-वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="mali_vadhu_var"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "Which is the best Mali matrimony Pune?",
                  answer: "Mali Vadhu Var from Pune could register free through MarathiVadhuVarSuchak.com to search profiles."
                },
                {
                  question: "Which is the best Chaukalshi Mali matrimony?",
                  answer: "MarathiVadhuVarSuchak.com is the best Mali matrimony to register free. After approval you can search list of all Chaukalshi Mali Grooms and brides."
                },
                {
                  question: "Which is the best Lingayat Vadhu Var Suchak Pune?",
                  answer: "MarathiVadhuVarSuchak.com is the most trusted Mali matrimony for brides and grooms staying in Pune."
                },
                {
                  question: "What services are offered by Mali Vadhu Var?",
                  answer: "MarathiVadhuVarSuchak.com offer free registration to Mali community vadhu var."
                },
                {
                  question: "What is a Vadhu Var Suchak Mandal?",
                  answer: "MarathiVadhuVarSuchak.com is best trausted Mali matrimony for Marathi Mali vadhu Var."
                },
                {
                  question: "How to join Mali vadhu var whatsapp group?",
                  answer: "Because of privacy reason, MarathiVadhuVarSuchak.com do not have any Mali vadhu var whatsapp group to join."
                },
                {
                  question: "How to search Mali Vadhu Var grooms profile?",
                  answer: "After free registration on MarathiVadhuVarSuchak.com, you can search Mali vadhu var grooms and brides profile online."
                },
                {
                  question: "How to join Mali Vadhu Var Whatsapp number?",
                  answer: "No! Due to privacy policy, MarathiVadhuVarSuchak.com do not have any whatsapp group to join."
                },
                {
                  question: "How to download Mali samaj vadhu list pdf file?",
                  answer: "No! You cannot download Mali samaj vadhu list pdf file on MarathiVadhuVarSuchak.com, but you can view list of Mali samaj vadhu var profiles after free registration."
                },
                {
                  question: "How to join Mali vikas matrimony online?",
                  answer: "Mali Vadhu Var could join MarathiVadhuVarSuchak.com through free registration. If profile is filled in details then after approval you can search Mali Vadhu Var profiles."
                },
                {
                  question: "How to get the Mali samaj Var list online?",
                  answer: "First visit MarathiVadhuVarSuchak.com to register free. After, profile approval you can search Mali Vadhu Var list online."
                },
                {
                  question: "How to search Mali Vadhu Var photos?",
                  answer: "Mali Vadhu Var can search profiles with photo on MarathiVadhuVarSuchak.com after free registration."
                },
                {
                  question: "How to search Mali samaj vadhu list female?",
                  answer: "You can search Mali samaj vadhu list on MarathiVadhuVarSuchak.com after free registration."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Mali Vadhu Var Suchak Mandal for Mali Community"
        items={communityServices}
      />

    </div>
  );
}

